import { StringUtilities } from './String.utility';
import { stringUtilitiesMock } from './String.utility.mock';
import { Util } from './Util';

const getMock: () => Partial<Util> = () => {
    const mockUtil = {
        strings: stringUtilitiesMock.getMock() as StringUtilities
    } as Util;
    mockUtil.newDate = () => ({}) as any;
    return mockUtil;
};

export const utilMock = {
    getMock,
    provider: (Service: typeof Util) => ({
        provide: Service,
        useValue: getMock()
    })
};
